import type { AttendanceSheetVM } from "@shared-kernel/application/ports/student/student-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const studentRetrieveAllAttendanceSheets = createApiThunk<AttendanceSheetVM[], void>(
  "attendanceSheets/studentRetrieveAllAttendanceSheets",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.getAllAttendanceSheets();
  },
);
